'use client';

import { freddyTheme, useMediaQuery } from '@coolblue-development/freddy';
import { Device } from '@coolblue-development/next-request-context';
import { useRequestContext } from '@coolblue-development/next-request-context/client';

export const useBreakpoints = () => {
  const { device } = useRequestContext();
  const isMobile = useMediaQuery(freddyTheme.breakpoint.maxWidth('md'), device === Device.MOBILE);
  const isTablet = useMediaQuery(freddyTheme.breakpoint.maxWidth('lg'), device === Device.TABLET);

  return {
    isMobile,
    isTablet
  };
};
